import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Zap,
  Shield,
  Wifi,
  Monitor,
  Printer,
  HardDriveDownload,
  Smartphone,
} from 'lucide-react';
import { SILOS } from '../../data/blog/silos';
import type { SiloId } from '../../types/blog';

const SILO_ICONS: Record<SiloId, React.ReactNode> = {
  performance: <Zap className="h-5 w-5" />,
  securite: <Shield className="h-5 w-5" />,
  reseau: <Wifi className="h-5 w-5" />,
  windows: <Monitor className="h-5 w-5" />,
  materiel: <Printer className="h-5 w-5" />,
  recuperation: <HardDriveDownload className="h-5 w-5" />,
  telephone: <Smartphone className="h-5 w-5" />,
};

interface SiloNavProps {
  activeSilo?: SiloId;
}

const SiloNav: React.FC<SiloNavProps> = ({ activeSilo }) => {
  return (
    <nav aria-label="Catégories du blog" className="py-6">
      <motion.div
        className="flex flex-wrap justify-center gap-3"
        initial="hidden"
        animate="show"
        variants={{
          hidden: {},
          show: { transition: { staggerChildren: 0.06 } },
        }}
      >
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 12 },
            show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
          }}
        >
          <Link
            to="/blog"
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium border transition-all duration-200 ${
              activeSilo === undefined
                ? 'bg-[#5865F2] border-[#5865F2] text-white'
                : 'border-white/15 bg-white/5 text-gray-300 hover:border-[#5865F2]/50 hover:text-white'
            }`}
          >
            Tous les articles
          </Link>
        </motion.div>

        {(Object.keys(SILOS) as SiloId[]).map((siloId) => {
          const silo = SILOS[siloId];
          const isActive = activeSilo === siloId;
          return (
            <motion.div
              key={siloId}
              variants={{
                hidden: { opacity: 0, y: 12 },
                show: { opacity: 1, y: 0, transition: { duration: 0.35, ease: 'easeOut' } },
              }}
            >
              <Link
                to={`/blog/silo/${siloId}`}
                className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium border transition-all duration-200 ${
                  isActive
                    ? `${silo.color} border-transparent text-white`
                    : 'border-white/15 bg-white/5 text-gray-300 hover:border-white/30 hover:text-white'
                }`}
              >
                {SILO_ICONS[siloId]}
                {silo.title}
              </Link>
            </motion.div>
          );
        })}
      </motion.div>
    </nav>
  );
};

export default SiloNav;
